import {forwardRef,type ImgHTMLAttributes} from 'react';
type Props=Omit<ImgHTMLAttributes<HTMLImageElement>,'src'> & {src:string|{src:string};fill?:boolean;priority?:boolean;unoptimized?:boolean;quality?:number;loader?:unknown};
export type ImageProps=Props;
export default forwardRef<HTMLImageElement,Props>(function Image({src,fill,priority,unoptimized:_u,quality:_q,loader:_l,style,...props},ref){
  return <img {...props} src={typeof src==='string'?src:src.src} ref={ref} loading={priority?'eager':props.loading}
    style={{...(fill?{position:'absolute',inset:0,width:'100%',height:'100%'}:undefined),...style}}/>;
});
